<template>
    <product-form></product-form>
</template>

<script>
    import { mapActions } from 'vuex'
    import ProductForm from './ProductForm'

    export default {
        created: function() {
            this.clearSelectedItem();
        },
        methods: {
            ...mapActions([
                'clearSelectedItem',
            ]),
        },
        components: {
            ProductForm
        }
    }
</script>


// WEBPACK FOOTER //
// ProductNew.vue?404f4673